import { trpc } from "@/trpc";

/** Data: User | null — user account for the given contact_id */
export function useUserByContactId(contactId: string) {
  return trpc.admin.users.getByContactId.useQuery(
    { contact_id: contactId },
    { enabled: !!contactId },
  );
}

/** Data: Registration | null — pending (non-rejected) registration for the given contact_id */
export function useRegistrationByContactId(contactId: string) {
  return trpc.admin.users.getRegistrationByContactId.useQuery(
    { contact_id: contactId },
    { enabled: !!contactId },
  );
}

/**
 * Count of pending registrations that are ready for admin review (form fully submitted).
 * Used by the nav badge, tab badge, and dashboard card.
 */
export function usePendingRegistrationCount(): { count: number; isLoading: boolean } {
  const { data, isLoading } = trpc.admin.users.pendingCount.useQuery();
  return { count: data?.registration_count ?? 0, isLoading };
}
